import {useNavigate} from "react-router-dom";

export default function Reset(props)
{
    sessionStorage.clear();
    const navigator = useNavigate();
    navigator('/');
    return(<div></div>)    
}